export default {
  'waitingInquiries': [],
  'bookeroNews': [],
  'notifications': [],
  'popupZindex': 10000,
  'popupsZindexes': {}
};



// WEBPACK FOOTER //
// ./src/store/default.state.global.js